import { Role } from "@/router/_helper";

  const requirement = {
    path: "/requirement",
    name: "requirement",
    component: () => import(/* webpackChunkName: "requirement" */ "@/components/requirement/RequirementIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "requirement" */ "@/components/requirement/RequirementView.vue"), name: "requirementView", meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true } },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "requirement" */ "@/components/requirement/RequirementEdit.vue"), name: "requirementEdit", meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true } },
      { path: "create", component: () => import(/* webpackChunkName: "requirement" */ "@/components/requirement/RequirementCreate.vue"), name: "requirementCreate", meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true }}
    ],
    meta: { authorize: [Role.Admin, Role.ComplianceAdmin], requiresAuth: true }
  };

export default requirement;
    